import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Auth from '@/components/user/Auth'
import UserProfile from '@/components/user/UserProfile'
import TeamProfile from '@/components/team/TeamProfile'
import TeamMembers from '@/components/team/Members'
import TeamInvite from '@/components/team/Invite'
import TeamJoin from '@/components/team/Join'
import Tournament from '@/components/tournament/TournamentDetail'
import TournamentEntered from '@/components/tournament/entered'
import TournamentConfirm from '@/components/tournament/TournamentConfirm'
import TournamentCancel from '@/components/tournament/TournamentCancel'
import TournamentSearch from '@/components/tournament/TournamentSearch'
import Schedule from '@/components/schedule/Index'
import Faq from '@/components/Faq'
import Rule from '@/components/Rule'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import Terms from '@/components/Terms'
import Home from '@/components/Home'
import Managementgroup from '@/components/Managementgroup'
import Sendgrid from '@/components/Sendgrid'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/sendgrid',
      name: 'Sendgrid',
      component: Sendgrid
    },
    {
      path: '/rule',
      name: 'Rule',
      component: Rule
    },
    {
      path: '/managementgroup',
      name: 'Managementgroup',
      component: Managementgroup
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule
    },
    {
      path: '/user/profile',
      name: 'UserProfile',
      component: UserProfile
    },
    // {
    //   path: '/team/profile',
    //   name: 'TeamProfile',
    //   component: TeamProfile
    // },
    {
      path: '/teams/:id',
      name: 'TeamProfile',
      component: TeamProfile
    },
    {
      path: '/team/:id/members',
      name: 'TeamMembers',
      component: TeamMembers
    },
    {
      path: '/team/:id/invite',
      name: 'TeamInvite',
      component: TeamInvite
    },
    {
      path: '/team/join/:id',
      name: 'TeamJoin',
      component: TeamJoin
    },
    {
      path: '/tournament/:id',
      name: 'Tounament',
      component: Tournament
    },
    {
      path: '/tournamententered/:id',
      name: 'TournamentEntered',
      component: TournamentEntered
    },
    {
      path: '/tournament',
      name: 'TournamentSearch',
      component: TournamentSearch
    },
    {
      path: '/tournamentconfirm/:id',
      name: 'TounamentConfirm',
      component: TournamentConfirm
    },
    {
      path: '/tournament/:id/cancel',
      name: 'TounamentCancel',
      component: TournamentCancel
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js